import { RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT } from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getNumberValue, getObjectValue } from 'utilities';
import type { CustomReverseParserPctParams } from './types';

const customReverseParserPct = (params: CustomReverseParserPctParams): void => {
  const { cells, rangeSensitivity } = params;
  let sensitivityPercentage = rangeSensitivity.sensitivity_percentage;

  Object.values(getObjectValue(cells)).forEach((cell: unknown) => {
    const { alias, columnLegend, value } = getObjectValue(cell as object) as {
      alias?: string;
      columnLegend?: string;
      value?: unknown;
    };
    if (alias === RANGE_SENSITIVITY_SPREADSHEET_SENSITIVITY_PCT && columnLegend === 'A') {
      const raw = getNumberValue(value as number | string | null | undefined);
      if (raw > 0) {
        sensitivityPercentage = String(raw / 100);
      }
    }
  });

  rangeSensitivity.sensitivity_percentage = sensitivityPercentage;
};

export default customReverseParserPct;
